import { signal } from '@angular/core';

/**
 * Shared `isAdminProfile` signal state. Extend this in a domain-scoped
 * `@Injectable()` state service (e.g. `EventProfileState`, `UserProfileState`)
 * to get a distinct DI token per domain without re-implementing the same
 * signal/setter pair in every profile area.
 */
export abstract class AdminProfileState {
    private readonly adminProfile = signal(false);

    readonly isAdminProfile = this.adminProfile.asReadonly();

    setIsAdminProfile(isAdmin: boolean): void {
        this.adminProfile.set(isAdmin);
    }
}
